export class VoluntaryModel {
  id: number;
  name: string;
  email: string;
  roles: string[];
  phone?: string;
  isActive: boolean;
  createdAt?: Date;
  updatedAt?: Date;

  // Roles específicos para voluntários
  static ROLES = {
    ROLE_VOLUNTARY: { CODE: 'ROLE_VOLUNTARY', DESC: 'Voluntário' },
  };
}
